/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

interface CloseBtnProps {
  text: string;
  handleCloseClick: () => void;
}

const CloseBtn: FC<CloseBtnProps> = ({ text, handleCloseClick }) => {
  return (
    <NeuButton
      aria-label={`close ${text}`}
      color="blue"
      data-testid={`close-${text.replace(/\s+/g, '-').toLowerCase()}-button`}
      icon="close"
      size="small"
      kind="primary"
      onClick={handleCloseClick}
    >
      {`Close ${text}`}
    </NeuButton>
  );
};

export default CloseBtn;
